/** @jsx jsx */

import { useState } from 'react';
import { css, jsx } from '@emotion/core';

export const Diamond = props => {
  const { styles } = props;

  return (
    <g>
      <path
        css={css(styles)}
        d="M13.73,6.76A8.26,8.26,0,0,1,7.12.15.17.17,0,0,0,6.94,0a.18.18,0,0,0-.18.15A8.24,8.24,0,0,1,.15,6.76.18.18,0,0,0,0,6.94a.17.17,0,0,0,.15.18,8.26,8.26,0,0,1,6.61,6.61.18.18,0,0,0,.18.15.17.17,0,0,0,.18-.15,8.27,8.27,0,0,1,6.61-6.61.17.17,0,0,0,.15-.18A.18.18,0,0,0,13.73,6.76Z"
      />
    </g>
  );
};

export const diamond = (
  <g>
    <path d="M13.73,6.76A8.26,8.26,0,0,1,7.12.15.17.17,0,0,0,6.94,0a.18.18,0,0,0-.18.15A8.24,8.24,0,0,1,.15,6.76.18.18,0,0,0,0,6.94a.17.17,0,0,0,.15.18,8.26,8.26,0,0,1,6.61,6.61.18.18,0,0,0,.18.15.17.17,0,0,0,.18-.15,8.27,8.27,0,0,1,6.61-6.61.17.17,0,0,0,.15-.18A.18.18,0,0,0,13.73,6.76Z" />
  </g>
);
